export default "__VITE_ASSET__DtOY6Nma__"